export enum TicketDepartment {
  Support = 'Support',
  Accounting = 'Accounting',
  CustomerSuccess = 'CustomerSuccess',
  PartnerSuccess = 'PartnerSuccess',
  Operations = 'Operations',
  Product = 'Product',
}
